import React from "react";
import {
  TextField,
  TextFieldProps,
  TextFieldSize,
  TextFieldSizes,
} from "../TextField/TextField";
import { BaseSelectProps } from "@mui/material";

export { SelectChangeEvent, selectClasses } from "@mui/material";

export const SelectSizes = TextFieldSizes;
export type SelectSize = TextFieldSize;

export const SelectColors = [
  "primary",
  "secondary",
  "success",
  "error",
  "info",
  "warning",
] as const;
export type SelectColor = (typeof SelectColors)[number];

export type SelectProps<Value = unknown> = Omit<
  TextFieldProps,
  "select" | "InputProps" | "value" | "onChange" | "SelectProps"
> &
  Omit<BaseSelectProps<Value>, "sx>"> & {
    selectSx?: BaseSelectProps<Value>["sx"];
    /** Accessible label for the select. Falls back to "Select" when omitted. */
    ariaLabel?: string;
  };

// Using TextField isntead of Select so that we can use label and helperText, and have consistent styling.
export const Select = <Value = unknown,>({
  /* extract _most_ Select specific props (see BaseSelectProps) */
  autoWidth,
  defaultOpen,
  displayEmpty,
  IconComponent,
  MenuProps,
  multiple,
  native,
  onChange,
  onClose,
  onOpen,
  open,
  renderValue,
  SelectDisplayProps,
  value,
  /* end of Select specific props */
  selectSx,
  ariaLabel,
  ...props
}: SelectProps<Value>) => (
  <TextField
    {...props}
    inputProps={{
      // eslint-disable-next-line i18next/no-literal-string
      "aria-label": ariaLabel || "Select",
      ...props.inputProps,
    }}
    select
    SelectProps={{
      autoWidth,
      defaultOpen,
      displayEmpty,
      IconComponent,
      MenuProps,
      multiple,
      native,
      onChange,
      onClose,
      onOpen,
      open,
      renderValue,
      SelectDisplayProps,
      value,
      sx: selectSx,
    }}
  />
);
